import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../../../utils/requestHeaders";
import { API_HOST } from "../../../utils/constants";
import { buildMutationHelper } from "../../../utils/buildMutationHelper";
import { setTimeAndAttendancePending } from "../../reducer/time-and-attendance/time-and-attendancePending";
import { defaultFromState } from "../../../utils/defaultFromState";

export const timeAndAttendancePendingApi = createApi({
  reducerPath: "timeAndAttendancePendingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
  }),
  endpoints: (builder) => ({
    getPendingData: buildMutationHelper(
      builder,
      ({
        page = undefined,
        itemsPerPage = undefined,
        pagination = undefined,
        projectId = undefined,
        sortBy = undefined,
        sortType = undefined,
        checkInDate = undefined,
        checkOutDate = undefined,

        client = localStorage?.selectedClientId ?? undefined,
      } = {}) => {
        return {
          url: "/tna/pending-project-tna",
          params: {
            page: page,
            itemsPerPage: itemsPerPage,
            pagination: pagination,
            projectId,
            sortBy,
            sortType,
            checkInDate: checkInDate,
            checkOutDate: checkOutDate,
            client,
          },
          method: "GET",
          headers: getHeaders(),
          defaultFromState: (getState, args) => {
            const {
              timeAndAttendancePending: {
                page,
                itemsPerPage,
                pagination,
                projectId,
                sortBy,
                sortType,
                checkInDate,
                checkOutDate,
                client,
              },
            } = getState();
            let stateParams = {
              page,
              itemsPerPage,
              pagination,
              projectId,
              sortBy,
              sortType,
              checkInDate,
              checkOutDate,
              client,
            };

            return defaultFromState(stateParams, args);
          },
        };
      },
      (response, dispatch) => {
        if (
          new URL(response?.meta?.request?.url).searchParams.get(
            "pagination"
          ) === null
        ) {
          const { data } = response?.data;
          const totalCount = response?.data?.totalItems;
          dispatch(
            setTimeAndAttendancePending({
              data,
              totalCount,
              errorMessage: "",
            })
          );
        } else {
          const exportData = response?.data;
          dispatch(
            setTimeAndAttendancePending({
              exportData,
              errorMessage: "",
            })
          );
        }
      },
      ({ error }, dispatch) => {
        dispatch(
          setTimeAndAttendancePending({ errorMessage: error?.data?.error })
        );
      }
    ),
  }),
});

export const { useGetPendingDataMutation } = timeAndAttendancePendingApi;
